import { render, staticRenderFns } from "./riskOfficeLoadPop.vue?vue&type=template&id=b0ad40ca"
import script from "./riskOfficeLoadPop.vue?vue&type=script&lang=js"
export * from "./riskOfficeLoadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ad40ca')) {
      api.createRecord('b0ad40ca', component.options)
    } else {
      api.reload('b0ad40ca', component.options)
    }
    module.hot.accept("./riskOfficeLoadPop.vue?vue&type=template&id=b0ad40ca", function () {
      api.rerender('b0ad40ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskOfficeLoadPop.vue"
export default component.exports